export default {
  methods: {
    /**
     * Format the group names
     *
     * @param groups
     * @returns {VueI18n.TranslateResult|string|*}
     */
    formatUserGroups(groups) {
      if (groups === undefined || groups.length === 0) return this.$t('users.none');

      const firstGroup = groups[0];

      return this.$tc('users.teams-summary', groups.length - 1, { groupName: firstGroup.name });
    },
  },
};
